import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=8c5c838c"
import script from "./Capacity.vue?vue&type=script&lang=js"
export * from "./Capacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports